webpackJsonp([25,39,40,42],{

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1270);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("9b012480", content, true, {});

/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".native .sidebar[data-v-264d0e2d]{padding:50px 20px 70px;width:80%;max-width:400px;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);color:#555}@media (min-width:600px){.native .sidebar[data-v-264d0e2d]{width:400px}}.native .sidebar-button[data-v-264d0e2d]{padding:13px;position:fixed;top:0;right:0;z-index:9999;outline:none;background-color:#fff}.native .sidebar-svg[data-v-264d0e2d]{width:30px;height:30px;line-height:1}.native .sidebar-item[data-v-264d0e2d]{padding:1em 0;border-bottom:1px solid #ccc}.native .sidebar-item[data-v-264d0e2d]:last-of-type{border-bottom:none}.native .sidebar-anchor[data-v-264d0e2d]{display:block;line-height:2}.native .sidebar .nav-h2[data-v-264d0e2d],.native .sidebar .nav-list[data-v-264d0e2d]{margin:0}.native .sidebar .nav-list:first-child .nav-item[data-v-264d0e2d]:first-child{border-top:1px solid #ccc}.native .sidebar .nav-item[data-v-264d0e2d]{border-bottom:1px solid #ccc;position:relative}.native .sidebar .nav-item-a[data-v-264d0e2d]{display:block;padding:1em;line-height:1}.native .sidebar .nav-item-a .fa[data-v-264d0e2d]{margin:auto;width:1em;height:1em;position:absolute;top:0;bottom:0;right:0}@media (min-width:768px){.native .sidebar-button[data-v-264d0e2d],.native .sidebar[data-v-264d0e2d]{display:none}}.desktop .sidebar[data-v-264d0e2d],.smartphone .sidebar[data-v-264d0e2d],.tablet .sidebar[data-v-264d0e2d]{padding:50px 20px 70px;width:80%;max-width:400px;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);color:#555}@media (min-width:600px){.desktop .sidebar[data-v-264d0e2d],.smartphone .sidebar[data-v-264d0e2d],.tablet .sidebar[data-v-264d0e2d]{width:400px}}.desktop .sidebar-button[data-v-264d0e2d],.smartphone .sidebar-button[data-v-264d0e2d],.tablet .sidebar-button[data-v-264d0e2d]{padding:13px;position:fixed;top:0;right:0;z-index:9999;outline:none;background-color:#fff}.desktop .sidebar-svg[data-v-264d0e2d],.smartphone .sidebar-svg[data-v-264d0e2d],.tablet .sidebar-svg[data-v-264d0e2d]{width:30px;height:30px;line-height:1}.desktop .sidebar-item[data-v-264d0e2d],.smartphone .sidebar-item[data-v-264d0e2d],.tablet .sidebar-item[data-v-264d0e2d]{padding:1em 0;border-bottom:1px solid #ccc}.desktop .sidebar-item[data-v-264d0e2d]:last-of-type,.smartphone .sidebar-item[data-v-264d0e2d]:last-of-type,.tablet .sidebar-item[data-v-264d0e2d]:last-of-type{border-bottom:none}.desktop .sidebar-anchor[data-v-264d0e2d],.smartphone .sidebar-anchor[data-v-264d0e2d],.tablet .sidebar-anchor[data-v-264d0e2d]{display:block;line-height:2}.desktop .sidebar .nav-h2[data-v-264d0e2d],.desktop .sidebar .nav-list[data-v-264d0e2d],.smartphone .sidebar .nav-h2[data-v-264d0e2d],.smartphone .sidebar .nav-list[data-v-264d0e2d],.tablet .sidebar .nav-h2[data-v-264d0e2d],.tablet .sidebar .nav-list[data-v-264d0e2d]{margin:0}.desktop .sidebar .nav-list:first-child .nav-item[data-v-264d0e2d]:first-child,.smartphone .sidebar .nav-list:first-child .nav-item[data-v-264d0e2d]:first-child,.tablet .sidebar .nav-list:first-child .nav-item[data-v-264d0e2d]:first-child{border-top:1px solid #ccc}.desktop .sidebar .nav-item[data-v-264d0e2d],.smartphone .sidebar .nav-item[data-v-264d0e2d],.tablet .sidebar .nav-item[data-v-264d0e2d]{border-bottom:1px solid #ccc;position:relative}.desktop .sidebar .nav-item-a[data-v-264d0e2d],.smartphone .sidebar .nav-item-a[data-v-264d0e2d],.tablet .sidebar .nav-item-a[data-v-264d0e2d]{display:block;padding:1em;line-height:1}.desktop .sidebar .nav-item-a .fa[data-v-264d0e2d],.smartphone .sidebar .nav-item-a .fa[data-v-264d0e2d],.tablet .sidebar .nav-item-a .fa[data-v-264d0e2d]{margin:auto;width:1em;height:1em;position:absolute;top:0;bottom:0;right:0}.desktop .sidebar-button[data-v-264d0e2d],.smartphone .sidebar-button[data-v-264d0e2d],.tablet .sidebar-button[data-v-264d0e2d]{position:absolute!important}.desktop .sidebar-button[data-v-264d0e2d],.desktop .sidebar[data-v-264d0e2d],.tablet .sidebar-button[data-v-264d0e2d],.tablet .sidebar[data-v-264d0e2d]{display:none}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/sidebar/SidebarStandard1/SidebarStandard1.vue"],"names":[],"mappings":"AAmCA,kCACI,uBAAwB,AACxB,UAAW,AACX,gBAAiB,AACjB,yGAAwH,AACxH,iGAAgH,AAChH,UAAY,CACf,AACD,yBACA,kCACQ,WAAa,CACpB,CACA,AACD,yCACM,aAAc,AACd,eAAgB,AAChB,MAAO,AACP,QAAS,AACT,aAAc,AACd,aAAc,AACd,qBAAuB,CAC5B,AACD,sCACM,WAAY,AACZ,YAAa,AACb,aAAe,CACpB,AACD,uCACM,cAAe,AACf,4BAA8B,CACnC,AACD,oDACQ,kBAAoB,CAC3B,AACD,yCACM,cAAe,AACf,aAAe,CACpB,AAID,sFACM,QAAU,CACf,AACD,8EACQ,yBAA2B,CAClC,AACD,4CACM,6BAA8B,AAC9B,iBAAmB,CACxB,AACD,8CACQ,cAAe,AACf,YAAiB,AACjB,aAAe,CACtB,AACD,kDACU,YAAa,AACb,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,OAAS,CAClB,AACD,yBAsBA,2EACU,YAAc,CACvB,CACA,AAyCD,2GAGI,uBAAwB,AACxB,UAAW,AACX,gBAAiB,AACjB,yGAAwH,AACxH,iGAAgH,AAChH,UAAY,CACf,AACD,yBACA,2GAGQ,WAAa,CACpB,CACA,AACD,gIAGM,aAAc,AACd,eAAgB,AAChB,MAAO,AACP,QAAS,AACT,aAAc,AACd,aAAc,AACd,qBAAuB,CAC5B,AACD,uHAGM,WAAY,AACZ,YAAa,AACb,aAAe,CACpB,AACD,0HAGM,cAAe,AACf,4BAA8B,CACnC,AACD,iKAGQ,kBAAoB,CAC3B,AACD,gIAGM,cAAe,AACf,aAAe,CACpB,AAMD,4QAGM,QAAU,CACf,AACD,+OAGQ,yBAA2B,CAClC,AACD,yIAGM,6BAA8B,AAC9B,iBAAmB,CACxB,AACD,+IAGQ,cAAe,AACf,YAAiB,AACjB,aAAe,CACtB,AACD,2JAGU,YAAa,AACb,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,OAAS,CAClB,AACD,gIAGI,2BAA8B,CACjC,AAwBD,wJAEM,YAAc,CACnB","file":"SidebarStandard1.vue","sourcesContent":["\n.native[data-v-264d0e2d] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.native .sidebar[data-v-264d0e2d] {\n    padding: 50px 20px 70px;\n    width: 80%;\n    max-width: 400px;\n    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);\n    color: #555;\n}\n@media (min-width: 600px) {\n.native .sidebar[data-v-264d0e2d] {\n        width: 400px;\n}\n}\n.native .sidebar-button[data-v-264d0e2d] {\n      padding: 13px;\n      position: fixed;\n      top: 0;\n      right: 0;\n      z-index: 9999;\n      outline: none;\n      background-color: #fff;\n}\n.native .sidebar-svg[data-v-264d0e2d] {\n      width: 30px;\n      height: 30px;\n      line-height: 1;\n}\n.native .sidebar-item[data-v-264d0e2d] {\n      padding: 1em 0;\n      border-bottom: 1px solid #ccc;\n}\n.native .sidebar-item[data-v-264d0e2d]:nth-last-of-type(1) {\n        border-bottom: none;\n}\n.native .sidebar-anchor[data-v-264d0e2d] {\n      display: block;\n      line-height: 2;\n}\n.native .sidebar .nav-h2[data-v-264d0e2d] {\n      margin: 0;\n}\n.native .sidebar .nav-list[data-v-264d0e2d] {\n      margin: 0;\n}\n.native .sidebar .nav-list:first-child .nav-item[data-v-264d0e2d]:first-child {\n        border-top: 1px solid #ccc;\n}\n.native .sidebar .nav-item[data-v-264d0e2d] {\n      border-bottom: 1px solid #ccc;\n      position: relative;\n}\n.native .sidebar .nav-item-a[data-v-264d0e2d] {\n        display: block;\n        padding: 1em 1em;\n        line-height: 1;\n}\n.native .sidebar .nav-item-a .fa[data-v-264d0e2d] {\n          margin: auto;\n          width: 1em;\n          height: 1em;\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          right: 0;\n}\n@media (min-width: 768px) {\n.native[data-v-264d0e2d] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n.native .sidebar[data-v-264d0e2d] {\n        display: none;\n}\n.native .sidebar-button[data-v-264d0e2d] {\n          display: none;\n}\n}\n@media (min-width: 1025px) {\n.native[data-v-264d0e2d] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n}\n.smartphone[data-v-264d0e2d],\n.tablet[data-v-264d0e2d],\n.desktop[data-v-264d0e2d] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.smartphone .sidebar[data-v-264d0e2d],\n  .tablet .sidebar[data-v-264d0e2d],\n  .desktop .sidebar[data-v-264d0e2d] {\n    padding: 50px 20px 70px;\n    width: 80%;\n    max-width: 400px;\n    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);\n    color: #555;\n}\n@media (min-width: 600px) {\n.smartphone .sidebar[data-v-264d0e2d],\n      .tablet .sidebar[data-v-264d0e2d],\n      .desktop .sidebar[data-v-264d0e2d] {\n        width: 400px;\n}\n}\n.smartphone .sidebar-button[data-v-264d0e2d],\n    .tablet .sidebar-button[data-v-264d0e2d],\n    .desktop .sidebar-button[data-v-264d0e2d] {\n      padding: 13px;\n      position: fixed;\n      top: 0;\n      right: 0;\n      z-index: 9999;\n      outline: none;\n      background-color: #fff;\n}\n.smartphone .sidebar-svg[data-v-264d0e2d],\n    .tablet .sidebar-svg[data-v-264d0e2d],\n    .desktop .sidebar-svg[data-v-264d0e2d] {\n      width: 30px;\n      height: 30px;\n      line-height: 1;\n}\n.smartphone .sidebar-item[data-v-264d0e2d],\n    .tablet .sidebar-item[data-v-264d0e2d],\n    .desktop .sidebar-item[data-v-264d0e2d] {\n      padding: 1em 0;\n      border-bottom: 1px solid #ccc;\n}\n.smartphone .sidebar-item[data-v-264d0e2d]:nth-last-of-type(1),\n      .tablet .sidebar-item[data-v-264d0e2d]:nth-last-of-type(1),\n      .desktop .sidebar-item[data-v-264d0e2d]:nth-last-of-type(1) {\n        border-bottom: none;\n}\n.smartphone .sidebar-anchor[data-v-264d0e2d],\n    .tablet .sidebar-anchor[data-v-264d0e2d],\n    .desktop .sidebar-anchor[data-v-264d0e2d] {\n      display: block;\n      line-height: 2;\n}\n.smartphone .sidebar .nav-h2[data-v-264d0e2d],\n    .tablet .sidebar .nav-h2[data-v-264d0e2d],\n    .desktop .sidebar .nav-h2[data-v-264d0e2d] {\n      margin: 0;\n}\n.smartphone .sidebar .nav-list[data-v-264d0e2d],\n    .tablet .sidebar .nav-list[data-v-264d0e2d],\n    .desktop .sidebar .nav-list[data-v-264d0e2d] {\n      margin: 0;\n}\n.smartphone .sidebar .nav-list:first-child .nav-item[data-v-264d0e2d]:first-child,\n      .tablet .sidebar .nav-list:first-child .nav-item[data-v-264d0e2d]:first-child,\n      .desktop .sidebar .nav-list:first-child .nav-item[data-v-264d0e2d]:first-child {\n        border-top: 1px solid #ccc;\n}\n.smartphone .sidebar .nav-item[data-v-264d0e2d],\n    .tablet .sidebar .nav-item[data-v-264d0e2d],\n    .desktop .sidebar .nav-item[data-v-264d0e2d] {\n      border-bottom: 1px solid #ccc;\n      position: relative;\n}\n.smartphone .sidebar .nav-item-a[data-v-264d0e2d],\n      .tablet .sidebar .nav-item-a[data-v-264d0e2d],\n      .desktop .sidebar .nav-item-a[data-v-264d0e2d] {\n        display: block;\n        padding: 1em 1em;\n        line-height: 1;\n}\n.smartphone .sidebar .nav-item-a .fa[data-v-264d0e2d],\n        .tablet .sidebar .nav-item-a .fa[data-v-264d0e2d],\n        .desktop .sidebar .nav-item-a .fa[data-v-264d0e2d] {\n          margin: auto;\n          width: 1em;\n          height: 1em;\n          position: absolute;\n          top: 0;\n          bottom: 0;\n          right: 0;\n}\n.smartphone .sidebar-button[data-v-264d0e2d],\n  .tablet .sidebar-button[data-v-264d0e2d],\n  .desktop .sidebar-button[data-v-264d0e2d] {\n    position: absolute !important;\n}\n.tablet[data-v-264d0e2d],\n.desktop[data-v-264d0e2d] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.tablet .sidebar[data-v-264d0e2d],\n  .desktop .sidebar[data-v-264d0e2d] {\n    display: none;\n}\n.tablet .sidebar-button[data-v-264d0e2d],\n    .desktop .sidebar-button[data-v-264d0e2d] {\n      display: none;\n}\n.desktop[data-v-264d0e2d] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./SidebarStandard1.l.scss": 1272,
	"./SidebarStandard1.m.scss": 1274,
	"./SidebarStandard1.s.scss": 1276,
	"./SidebarStandard1.scss": 1278
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1271;

/***/ }),

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1273);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 1274:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1275);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1275:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".sidebar,.sidebar-button{display:none}", ""]);

// exports


/***/ }),

/***/ 1276:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1277);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".sidebar{padding:50px 20px 70px;width:80%;max-width:400px;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);color:#555}@media (min-width:600px){.sidebar{width:400px}}.sidebar-button{padding:13px;position:fixed;top:0;right:0;z-index:9999;outline:none;background-color:#fff}.sidebar-svg{width:30px;height:30px;line-height:1}.sidebar-item{padding:1em 0;border-bottom:1px solid #ccc}.sidebar-item:last-of-type{border-bottom:none}.sidebar-anchor{display:block;line-height:2}.sidebar .nav-h2,.sidebar .nav-list{margin:0}.sidebar .nav-list:first-child .nav-item:first-child{border-top:1px solid #ccc}.sidebar .nav-item{border-bottom:1px solid #ccc;position:relative}.sidebar .nav-item-a{display:block;padding:1em;line-height:1}.sidebar .nav-item-a .fa{margin:auto;width:1em;height:1em;position:absolute;top:0;bottom:0;right:0}", ""]);

// exports


/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1279);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".sidebar{padding:50px 20px 70px;width:80%;max-width:400px;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);color:#555}@media (min-width:600px){.sidebar{width:400px}}.sidebar-button{padding:13px;position:fixed;top:0;right:0;z-index:9999;outline:none;background-color:#fff}.sidebar-svg{width:30px;height:30px;line-height:1}.sidebar-item{padding:1em 0;border-bottom:1px solid #ccc}.sidebar-item:last-of-type{border-bottom:none}.sidebar-anchor{display:block;line-height:2}.sidebar .nav-h2,.sidebar .nav-list{margin:0}.sidebar .nav-list:first-child .nav-item:first-child{border-top:1px solid #ccc}.sidebar .nav-item{border-bottom:1px solid #ccc;position:relative}.sidebar .nav-item-a{display:block;padding:1em;line-height:1}.sidebar .nav-item-a .fa{margin:auto;width:1em;height:1em;position:absolute;top:0;bottom:0;right:0}@media (min-width:768px){.sidebar,.sidebar-button{display:none}}", ""]);

// exports


/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.component.contents)?[_c('div',{class:['component', _vm.previewSize],style:(_vm.hideAll ? 'display:none' : '')},[_c('div',{on:{"click":function($event){_vm.isEditing = !_vm.lock}}},[_c('mimic-amp-sidebar',{attrs:{"side":"top-right"}},[_c('nav',{staticClass:"sidebar-nav"},[_c('h2',{staticClass:"sidebar-nav-h2"},[_c('a',{staticClass:"sidebar-nav-a"},[(_vm.logo.src)?_c('mimic-amp-img',{attrs:{"image":_vm.logo}}):_vm._e(),_vm._v(" "),(!_vm.logo.src)?_c('div',{staticStyle:{"color":"red"}},[_vm._v("Settingsでロゴを設定して選択してください。")]):_vm._e()],1)]),_vm._v(" "),_c('ul',{staticClass:"nav-list"},[_vm._l((_vm.publishedPages),function(page,index){return [(page.parent === 0)?_c('li',{key:index,staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-a"},[_vm._v(_vm._s(page.title.rendered)),_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])]):_vm._e()]})],2)])])],1)])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__ = __webpack_require__(450);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e587aeb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__ = __webpack_require__(131);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'component-form-footer': __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__["default"]
  },
  data: function data() {
    return {
      name: this.$options.name,
      newPosition: this.index + 1,
      isEditing: false,
      extensions: []
    };
  },

  props: {
    index: { type: Number, default: null },
    bus: { type: Object, default: null },
    positionMax: { type: Number, default: null },
    component: { type: Object, default: null },
    components: { type: Array, default: null },
    hideAll: { type: Boolean, default: false },
    lock: { type: Boolean, default: false },
    previewSize: { type: String, default: 'native' },
    inPreview: { type: Boolean, default: false }
  },
  computed: {
    contents: {
      get: function get() {
        return this.component.contents;
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      }
    },
    meta: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].components[this.component.id].meta;
      }
    },
    posts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/all'];
      }
    },
    publishedPosts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/published'];
      }
    },
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    },
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    },
    themes: {
      get: function get() {
        return this.$store.getters['wordpress/themes/all'];
      }
    },
    settings: {
      get: function get() {
        return this.$store.getters['wordpress/settings/all'];
      }
    },
    sectionId: {
      get: function get() {
        return this.componentId(this);
      }
    },
    sectionClass: {
      get: function get() {
        return this.meta.file + ' ' + this.meta.file + '-' + this._uid + ' ' + (this.contents.bg.isCustom ? this.meta.file + '-' + this._uid + '-bg' : 'theme-base-bg-color') + ' slide';
      }
    },
    sectionClassArray: {
      get: function get() {
        return [this.meta.file, 'slide', 'theme-base-bg-color'];
      }
    },
    sectionStyle: {
      get: function get() {
        return this.contents.bg.isCustom ? 'background-color:' + this.contents.bg.color : '';
      }
    },
    containerClass: {
      get: function get() {
        return (this.contents.fullWidth ? '' : 'container') + (this.contents.padding.y ? ' py' + this.contents.padding.y : '');
      }
    },
    containerClassArray: {
      get: function get() {
        return [this.contents.fullWidth ? '' : 'container', 'py' + this.contents.padding.y];
      }
    },
    gridClass: {
      get: function get() {
        return 'grid grid-mx' + this.contents.layout.margin + ' grid-my' + this.contents.layout.margin + ' grid-1-' + this.contents.layout.s + ' grid-1-' + this.contents.layout.m + '-m grid-1-' + this.contents.layout.l + '-l';
      }
    },
    gridClassArray: {
      get: function get() {
        return ['grid', 'grid-mx' + this.contents.layout.margin, 'grid-my' + this.contents.layout.margin, 'grid-1-' + this.contents.layout.s, 'grid-1-' + this.contents.layout.m + '-m', 'grid-1-' + this.contents.layout.l + '-l'];
      }
    }
  },
  methods: {
    /**
     各コンポーネントに付与するIDを返す関数
     */
    componentId: function componentId(that) {
      return that.component ? that.component.meta.file + '-' + that._uid : that.meta.file + '-' + that._uid;
    },

    /**
     * uuid生成関数
     *
     * @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
     */
    uuidv4: function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function getThemeInlineStyle(prop, type) {
      return prop + ': rgba(' + this.themes.colors[type].rgba.r + ', ' + this.themes.colors[type].rgba.g + ', ' + this.themes.colors[type].rgba.b + ', ' + this.themes.colors[type].rgba.a + ')';
    },

    /**
     * 引数で与えられるIDの固定ページを返す関数
     */
    getPageById: function getPageById(id) {
      return this.pages.find(function (page) {
        return page.id === id;
      });
    },

    /**
     * 引数で与えられるIDの固定ページの子ページを返す関数
     */
    getSubPagesById: function getSubPagesById(id) {
      return this.pages.filter(function (page) {
        return page.parent === id && page.status === 'publish';
      });
    },

    /**
     * 適用ボタンを押すとthis.components.contentsからHTMLとCSSを
     * 生成してupdateイベントを発火する
     *
     * 適用ボタンを押すとthis.component.htmlとthis.component.cssを更新する
     */
    updateComponent: function updateComponent() {
      if (false) console.log('Running updateComponent of ' + this.name + '...');

      this.component.html = this.generateHtml(this.component.contents);
      this.component.css = this.generateCss(this.component.contents);
      this.$emit('update', { component: this.component, newPosition: this.newPosition });
      this.isEditing = false;
    },

    updateComponentUid: function updateComponentUid() {
      /**
       * this._uid は vue でコンポーネントが生成された際に発行される。
       * この値は発行時にユニークであるため、あとでコンポーネントが追加されたり
       * コンポーネント入れ替え時に新規に発行されても、最初に発行された this._uid とは被らない（はず）。
       * updateComponentUid が呼び出されたらイベントバスで uid-updated イベントを発火して、
       * this.component._uid に this._uid を代入して最新の this._uid をコンポーネント内に保持する
       *
       */
      if (this.component._uid !== this._uid) {
        if (false) console.log('%c_uid has been changed: ' + this.component._uid + ' -> ' + this._uid, 'color:blue');
        this.bus.$emit('uid-updated', this);
        this.component._uid = this._uid;
        if (false) console.log('%c_uid has been updated: this.component._uid = ' + this.component._uid, 'color:teal');
      }
    },

    updateComponentAndUid: function updateComponentAndUid() {
      this.updateComponentUid();
      this.updateComponent();
    },

    /**
     * コンポーネント削除用のdeleteイベントを発火する
     */
    deleteComponent: function deleteComponent() {
      this.$emit('delete');
      this.isEditing = false;
    }
  },
  /**
   * コンポーネント生成時にHTMLとCSSを生成してupdateイベントを発火する
   */
  created: function created() {
    if (!this.component._uid) this.component._uid = this._uid;
    if (this.component.uid) delete this.component.uid;
    this.updateComponent();
  },
  /**
   * コンポーネントマウント時にmountedイベントを発火する
   */
  mounted: function mounted() {
    this.$emit('mounted');
    this.bus.$on('update-child', this.updateComponentAndUid);
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__ = __webpack_require__(455);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__ = __webpack_require__(461);
function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e0f36de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStandard1_vue__ = __webpack_require__(822);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_264d0e2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStandard1_vue__ = __webpack_require__(1280);
function injectStyle (ssrContext) {
  __webpack_require__(1269)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-264d0e2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarStandard1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_264d0e2d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarStandard1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'component-form-footer',
  methods: {
    onDelete: function onDelete() {
      this.$emit('delete');
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onUpdate: function onUpdate() {
      this.$emit('update');
    }
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("727fe8b8", content, true, {});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ComponentFormFooter.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.onDelete()}}},[_vm._v("削除")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdate}},[_vm._v("適用")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mimic-amp-img',
  props: ['image']
});

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(460);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("2434fe00", content, true, {});

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".amp-img[data-v-7e0f36de]{display:block;width:100%;position:relative;overflow:hidden!important}.amp-img-sizer[data-v-7e0f36de]{display:block!important}.amp-img-content[data-v-7e0f36de]{display:block;margin:auto;border:none!important;padding:0!important;width:0;max-width:100%;min-width:100%;height:0;max-height:100%;min-height:100%;position:absolute;top:0;left:0;right:0;bottom:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/mimic-amp/MimicAmpImg.vue"],"names":[],"mappings":"AAsBA,0BACE,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,yBAA4B,CAC7B,AACD,gCACI,uBAA0B,CAC7B,AACD,kCACI,cAAe,AACf,YAAa,AACb,sBAAwB,AACxB,oBAAsB,AACtB,QAAS,AACT,eAAgB,AAChB,eAAgB,AAChB,SAAU,AACV,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,QAAU,CACb","file":"MimicAmpImg.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.amp-img[data-v-7e0f36de] {\n  display: block;\n  width: 100%;\n  position: relative;\n  overflow: hidden !important;\n}\n.amp-img-sizer[data-v-7e0f36de] {\n    display: block !important;\n}\n.amp-img-content[data-v-7e0f36de] {\n    display: block;\n    margin: auto;\n    border: none !important;\n    padding: 0 !important;\n    width: 0;\n    max-width: 100%;\n    min-width: 100%;\n    height: 0;\n    max-height: 100%;\n    min-height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amp-img"},[_c('div',{staticClass:"amp-img-sizer",style:('padding-top:' + _vm.image.height / _vm.image.width * 100 + '%')}),_vm._v(" "),_c('img',{staticClass:"amp-img-content",attrs:{"src":_vm.image.src}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_mixins_ComponentBase__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mimic_amp_MimicAmpImg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mimic_amp_MimicAmpSidebar__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-standard-1',
  components: {
    'mimic-amp-img': __WEBPACK_IMPORTED_MODULE_1__components_mimic_amp_MimicAmpImg__["default"],
    'mimic-amp-sidebar': __WEBPACK_IMPORTED_MODULE_2__components_mimic_amp_MimicAmpSidebar__["default"]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_mixins_ComponentBase__["default"]],
  computed: {
    logo: function logo() {
      return this.settings.site.logo;
    }
  },
  methods: {
    /**
     * コンポーネントのHTMLを生成
     */
    generateHtml: function generateHtml(contents) {
      var html = '\n      <amp-sidebar class="sidebar theme-base-bg-color" id="sidebar" layout="nodisplay" side="right">\n        <button class="sidebar-button close" on="tap:sidebar.close" role="button" tabindex=1><svg class="sidebar-svg theme-accent-fill-color" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5 c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9 c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/></svg></button>\n        <nav class="sidebar-nav">\n          <h2 class="sidebar-nav-h2">\n            <a class="sidebar-nav-a" href="' + this.url + '">\n              <amp-img width="' + this.logo.width + '" height="' + this.logo.height + '" layout="responsive" src="' + this.logo.src + '" alt="' + this.settings.site.owner + '\u30ED\u30B4\u753B\u50CF" attribution="' + this.settings.site.owner + ' All Rights Reserved."><p fallback>' + this.settings.site.owner + '</p>\n              </amp-img>\n            </a>\n          </h2>\n          getNavListType1\n        </nav>\n      </amp-sidebar>\n\n      <button class="sidebar-button open" on="tap:sidebar.toggle" role=button tabindex=0><svg class="sidebar-svg theme-accent-fill-color" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M417.4,224H94.6C77.7,224,64,238.3,64,256c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,238.3,434.3,224,417.4,224z"/><path d="M417.4,96H94.6C77.7,96,64,110.3,64,128c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,110.3,434.3,96,417.4,96z"/><path d="M417.4,352H94.6C77.7,352,64,366.3,64,384c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,366.3,434.3,352,417.4,352z"/></svg>\n      </button>';
      return html.replace(/>\s+</g, '><').replace(/(\r\n|\n|\r)/gm, '').replace(/^\s+|\s+$/g, '');
    },
    /**
     * コンポーネントのCSSを生成
     */
    generateCss: function generateCss(contents) {
      var layout = __webpack_require__(1271)("./" + this.meta.file + '.scss');
      var theme = '';
      return { layout: layout, theme: theme };
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/25.d5ec7cda47917dbb9066.js